import App from 'app/app.js';

function PostalCodeValidationService() {
  var canadianPostalCodeRegex = /^[A-Za-z]\d[A-Za-z]( |-)?\d[A-Za-z]\d$/;
  var usPostalCodeRegex = /^(\d{5}-\d{4})$|^(\d{5})$/;

  this.postalCodeValidator = function (stateProvince, postalCode) {
    if (!stateProvince || !postalCode) {
      return true;
    }

    var pattern = stateProvince.country === 'CA' ? canadianPostalCodeRegex : usPostalCodeRegex;

    return pattern.test(postalCode);
  };

  this.convertPostalCode = function (postalCode) {
    if (!postalCode) {
      return null;
    }

    var result = postalCode.toUpperCase();

    if (canadianPostalCodeRegex.test(result)) {
      if (result.length === 6) {
        return result.substring(0, 3) + ' ' + result.substring(3, 6);
      }

      if (result.indexOf('-') === 3) {
        return result.substring(0, 3) + ' ' + result.substring(4, 7);
      }
    }

    return result;
  };
}

App.service('PostalCodeValidationService', [PostalCodeValidationService]);
